import { KeyIndexImpl } from '../instructions';
/**
 * @public
 */
export var PluralDigitValues = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
/**
 * @public
 */
export var CurrencySpacingPosIndex = new KeyIndexImpl(['before', 'after']);
/**
 * @public
 */
export var CurrencySpacingPatternIndex = new KeyIndexImpl([
    'currencyMatch',
    'surroundingMatch',
    'insertBetween',
]);
/**
 * @public
 */
export var NumberSymbolValues = [
    'approximatelySign',
    'currencyDecimal',
    'currencyGroup',
    'decimal',
    'exponential',
    'group',
    'infinity',
    'list',
    'minusSign',
    'nan',
    'perMille',
    'percentSign',
    'plusSign',
    'superscriptingExponent',
    'timeSeparator',
];
/**
 * @public
 */
export var NumberSystemCategoryValues = ['default', 'native', 'finance', 'traditional'];
/**
 * @public
 */
export var NumberMiscPatternValues = ['at-least', 'at-most', 'approx', 'range'];
/**
 * @public
 */
export var NumberMiscPatternIndex = new KeyIndexImpl(NumberMiscPatternValues);
/**
 * @public
 */
export var NumberSystemsIndex = new KeyIndexImpl(NumberSystemCategoryValues);
/**
 * @public
 */
export var NumberSymbolIndex = new KeyIndexImpl(NumberSymbolValues);
//# sourceMappingURL=numbers.js.map